// 密码加密规则
import md5 from 'crypto-js/md5'
import HmacSHA256 from 'crypto-js/hmac-sha256'
import EncBase64 from 'crypto-js/enc-base64'

export const encodePwd = word => {
  const key = 'bonreesecret'
  return EncBase64.stringify(HmacSHA256(md5(word).toString(), key))
}

export const debounce = (fn, wait) => {
  let timeout = null
  return function () {
    if (timeout !== null) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      fn.apply(this, arguments)
    }, wait)
  }
}

// 生成随机orderid保证唯一性
export const randomOrderId = () => {
  let random = '';
  for(let i=0; i<3; i++) {
    random += Math.floor(Math.random()*10);
  }
  return new Date().getTime() + random;
}